module.exports = __webpack_public_path__ + "img/unavailable_distribution.03ff455b.svg";